import Splitting from "splitting";

export default class SplittingComponent {
    init() {
        const selector = ".u-split > span";
        const elements = Array.from(document.querySelectorAll(selector));

        // Aggiungo i pulsanti dentro ai custom <mtl-marquee>
        document.querySelectorAll("mtl-marquee").forEach(component  => {
            if (component.shadowRoot) {
                component.shadowRoot.querySelectorAll(selector).forEach(element => elements.push(element));
            }
        });

        // ciclo tutto ed eseguo lo split
        elements.forEach(element => {
            if (element.classList.contains("splitting")) {
                return;
            }

            Splitting({
                target: element,
                by: "chars"
            });
        })
    }
}
